import { Dialog } from 'primereact/dialog'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { useMountEffect } from 'primereact/hooks'
import { CommonContext } from '../common/context/commonContext'
import { InventorySupplementScanDialogProps } from '../../types/inventory'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySupplementScanDialog = (props: InventorySupplementScanDialogProps) => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()

    const scanRef = useRef<HTMLInputElement>(null)
    const [lctSeq, setLctSeq] = useState<string>('')

    useMountEffect(() => {
        setTimeout(() => scanRef.current?.focus(), 100)
    })

    useEffect(() => {
        if (props.visible) {
            setLctSeq('') // reset
            console.log('재고보충 스캔', props.detail)
        }
    }, [props.visible])

    const onKeyDownSearch = debounce(async (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            let result
            if (props.detail.lctScanTyp === 'SRC') {
                if (lctSeq !== props.detail.srcLctSeq) {
                    $toast({
                        title: t(tokens.common.scan_departure_barcode),
                        text: props.detail.srcLctNm + `\n${t(tokens.common.please_scan_the_barcode)}`,
                        icon: 'warn',
                    })
                    return
                }
                result = await $http().put('/inventory/supplement-scan/depart', {
                    inventorySupplementDetailSeq: props.detail.inventorySupplementDetailSeq,
                    departLctSeq: props.detail.srcLctSeq,
                    goodsQty: props.detail.supplementGoodsQty,
                })
                if (result) {
                    result = {
                        isScan: true,
                        message: result.message,
                    }
                }
            } else if (props.detail.lctScanTyp === 'DEST') {
                if (lctSeq !== props.detail.destLctSeq) {
                    $toast({
                        title: t(tokens.common.scan_arrival_barcode),
                        text: props.detail.destLctNm + `\n${t(tokens.common.please_scan_the_barcode)}`,
                        icon: 'warn',
                    })
                    return
                }
                result = await $http().put('/inventory/supplement-scan/arrival', {
                    inventorySupplementDetailSeq: props.detail.inventorySupplementDetailSeq,
                    arrivalLctSeq: props.detail.destLctSeq,
                })

                if (result) {
                    result = {
                        isScan: true,
                        message: t(tokens.common.inventory_replenishment_has_been_processed),
                    }
                }
            } else {
                props.onHide && props.onHide(false)
                return
            }
            if (result && result.isScan) {
                $toast({
                    title: t(tokens.common.success),
                    text: result.message,
                    icon: 'success',
                })
                props.onHide && props.onHide(true)
            }
        }
    }, 1000)

    const footer = () => {
        return (
            <>
                <Button
                    className="mt-1 w-full p-button-secondary"
                    label={t(tokens.common.close)}
                    size="small"
                    onClick={() => props.onHide && props.onHide(false)}
                />
            </>
        )
    }

    return (
        <Dialog
            header={props.detail.lctScanTyp === 'SRC' ? t(tokens.common.scan_departure_barcode) : t(tokens.common.scan_arrival_barcode)}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide(false)}
            closable={false}
            contentClassName="pb-0"
            footer={footer}
        >
            <div className="flex grid m-1 mb-3">
                <span className="p-input-icon-left mt-1">
                    <i className="pi pi-map-marker" />
                    <InputText
                        ref={scanRef}
                        value={lctSeq}
                        className="p-inputtext-md w-full"
                        placeholder={
                            props.detail.lctScanTyp === 'SRC' ? t(tokens.common.scan_departure_barcode) : t(tokens.common.scan_arrival_barcode)
                        }
                        onChange={(e) => setLctSeq(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                    />
                </span>
            </div>
        </Dialog>
    )
}

export default InventorySupplementScanDialog
